import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import CountrySettings from './Components/CountrySettings'
import CitySettings from './Components/CitySettings'
import PrintingCosts from './Components/PrintingCosts'
import CountryPage from 'Containers/Country/Page'
import { DMPrintingCosts as DMPrintingCostsTable } from './Components/DMPrintingCosts'
import { ADMPrintingCosts as ADMPrintingCostsTable } from './Components/ADMPrintingCosts'
import { PrintersTable } from './Components/Printers'

const directMailOnlyCities = ['Canada', 'USA', 'Australia', 'New Zealand']

const SelfSerfSettings = ({ country, refetch }) => {
  const {
    id,
    currencySign,
    countryDefaultSettings,
    citiesSettings: { nodes: citiesSettingsProps },
    printingCosts: { nodes: printingCosts },
    DMPrintingCosts,
    ADMPrintingCosts,
    Printers,
    States,
  } = country

  const isDMEnabled = id == 14

  const citiesSettings = citiesSettingsProps.filter(
    ({ name }) => !directMailOnlyCities.includes(name),
  )

  const [newCountrySettings, setNewCountrySettings] = useState(
    countryDefaultSettings,
  )
  const [isEditingTable, setIsEditingTable] = useState(false)

  return (
    <CountryPage
      country={country}
      breadcrumbs={[
        {
          label: 'Settings',
        },
      ]}
    >
      <Box>
        <CountrySettings
          refetch={refetch}
          countryId={id}
          currencySign={currencySign}
          citiesSettings={citiesSettings}
          countryDefaultSettings={countryDefaultSettings}
          setNewCountrySettings={setNewCountrySettings}
          printingCosts={printingCosts}
          isEditingTable={isEditingTable}
          setIsEditingTable={setIsEditingTable}
        />
        <CitySettings
          countryId={id}
          refetch={refetch}
          currencySign={currencySign}
          citiesSettings={citiesSettings}
          countrySettings={newCountrySettings}
          isEditingTable={isEditingTable}
          setIsEditingTable={setIsEditingTable}
        />
        <PrintingCosts
          countryId={id}
          printingCostsData={printingCosts}
          isEditingTable={isEditingTable}
        />
        <DMPrintingCostsTable
          countryId={id}
          currencySign={currencySign}
          DMPrintingCostsData={DMPrintingCosts}
          isEditingTable={isEditingTable}
          visible={!!isDMEnabled}
        />
        <ADMPrintingCostsTable
          countryId={id}
          currencySign={currencySign}
          ADMPrintingCostsData={ADMPrintingCosts}
          isEditingTable={isEditingTable}
          visible={!!isDMEnabled}
        />
        <PrintersTable
          countryId={id}
          printersData={Printers}
          statesData={States}
          refetch={refetch}
          visible={!!isDMEnabled}
        />
      </Box>
    </CountryPage>
  )
}

export default SelfSerfSettings
